module.exports = __webpack_public_path__ + "static/PIO2000-INT-27adc179b4c877afbf9a7435dec5318f.jpg";